<template>
    <div class="fill-height mt-3">
		<!-- add new category dialog -->
		<v-dialog v-model="dialog" width="400">
			<v-card class="rounded-lg ">
				<!-- header dialog -->
				<v-card-title class="pt-3 pb-0">
					<span class="title"> {{ !categoryId ? 'Add categories' : 'Edit categories' }} </span>
				</v-card-title>

				<v-card-text class="pt-2 pb-1">
					<v-row>
						<v-col>
							<v-text-field
								v-model="name"
								label="Name"
								dense
								solo
								:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''"
								hide-details="auto"
								:disabled="submitLoading"
								class="rounded-lg input"
							/>
						</v-col>
						<v-col>
							<v-autocomplete
								v-model="parentId"
								:items="categories"
								item-text="name"
								item-value="id"
								label="Parent"
								dense
								solo
								:background-color="!$vuetify.theme.dark ? 'grey lighten-5' : ''"
								hide-details="auto"
								:disabled="submitLoading"
								class="rounded-lg input"
							/>
						</v-col>
					</v-row>
				</v-card-text>

				<v-card-actions>
					<v-spacer/>
					<v-btn
						color="green-color white--text"
						:loading="submitLoading"
						@click="submit()"
						class="text-none rounded-lg"
					>
						Save
					</v-btn>

					<v-btn
						@click="dialog = false"
						:disabled="submitLoading"
						class="text-none rounded-lg"
						color="alert-color white--text"
					>
						Cancel
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- delete dialog -->
		<v-dialog v-model="deleteDialog" width="400">
			<v-card>
				<v-card-title class="pt-3 pb-1">
					<span class="title"> Delete category </span>
				</v-card-title>
				
				<v-card-text class="pb-1 pt-0 px-5">
					<span> Are you sure to deleting this category? </span>
				</v-card-text>

				<v-card-actions class="pt-0">
					<v-spacer />
					<v-btn
						@click="deleteCategory()"
						color="alert-color white--text"
						class="text-none rounded-lg"
						:loading="submitLoading"
					>
						Yes
					</v-btn>

					<v-btn
						@click="deleteDialog = false"
						class="text-none rounded-lg"
						:disabled="submitLoading"
					>
						Cancel
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-row align="center" class="justify-between pt-2">
			<v-spacer />
			<v-col cols="auto" class="d-flex justify-end py-0">
				<v-spacer />
				<v-btn
					@click="dialog = true"
					class="text-none rounded-lg"
					color="green-color white--text"
					:disabled="loading"
				>
					<v-icon small> mdi-plus </v-icon>
					Add categories
				</v-btn>
			</v-col>

			<v-col cols="12">
				<bee-handy-table 
					:headers="headers"
					:items="categories"
					zebra
					outlined
					dense
					table-class="rounded-lg"
					:loading="loading"
					pagination-on-scroll
					fixed-header
					:items-per-page="-1"
					:height="$vuetify.breakpoint.height - 200"
					elevation="0"
				>
					<template v-slot:item.actions="{ item }">
						<div>
							<v-btn 
								icon
								:to="{
									name: 'projects',
									query: {
										categoryId: item.id
									}
								}"
								color="success"
								:disabled="loading"
							>
								<v-icon> mdi-eye </v-icon>
							</v-btn>
							<v-btn
								@click="categoryId = item.id; dialog = true"
								icon
								color="edit-color"
								:disabled="loading"
							>
								<v-icon> mdi-pencil </v-icon>
							</v-btn>

							<v-btn
								@click="categoryId = item.id; deleteDialog = true"
								icon
								color="alert-color"
								:disabled="loading"
							>
								<v-icon>mdi-delete</v-icon>
							</v-btn>
						</div>
					</template>
				</bee-handy-table>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
export default {
	watch: {
		dialog (val) {
			if (val) {
				const category = this.getCategoryById(this.categoryId)
				if (this.categoryId !== null) {
					this.name = category?.name
					this.parentId = category?.parentId
				}
			} else {
				this.name = null
				this.parentId = null
				this.categoryId = null
			}
		}
	},

	data () {
		return {
			dialog: false,
			deleteDialog: false,
			name: null,
			parentId: null,
			submitLoading: false,
			loading: false,
			categoryId: null
		}
	},

	computed: {
		...mapState({
			categories: state => state.categories.categories
		}),

		...mapGetters({
			getCategoryById: 'categories/getCategoryById'
		}),

		headers () {
			return [
				{
					text: 'Name',
					name: 'name',
					value: 'name'
				},
				{
					text: 'parentId',
					name: 'parent',
					value: 'parentId',
					setValueExpr: val => val ? this.getCategoryById(val)?.name : '-'
				},
				// {
				// 	text: 'No of Project',
				// 	name: 'noProject',
				// 	value: 'noOfProject'
				// },
				{
					text: 'actions',
					name: 'actions',
					value: 'actions'
				}
			]
		}
	},

	methods: {
		submit () {
			this.loading = true
			this.submitLoading = true
			const actionName = this.categoryId !== null ? 'update' : 'create'
			this.$store.dispatch(`categories/${actionName}`, { 
				id: this.categoryId, 
				name: this.name, 
				parentId: this.parentId 
			}).then(() => {
				this.fetchAll()
				this.submitLoading = false
				this.dialog = false
			}).finally(() => {
				this.loading = false
				this.categoryId = null
			})
		},

		fetchAll () {
			return this.$store.dispatch('categories/fetchAll')
		},

		deleteCategory () {
			this.submitLoading = true
			this.$store.dispatch('categories/delete', { id: this.categoryId }).then(() => {
				this.loading = true
				this.fetchAll().finally(() => {
					this.loading = false
				})
				this.deleteDialog = false
				this.submitLoading = false
			}).finally(() => {
				this.categoryId = null
			})
		}
	},

	created () {
		this.loading = true
		this.fetchAll().finally(() => {
			this.loading = false
		})
	}
}
</script>
<style scoped>

</style>
